import { sanitize } from '../../utilities/dompurify';

export function sanitizeContentStripAll(dirtyContent: string): string {
  return sanitize(dirtyContent, {
    ALLOWED_ATTR: [],
    ALLOWED_TAGS: [],
  });
}
